import * as React from "react";
import { SvgIcon, SvgIconProps } from "../widget";

export default (props: SvgIconProps) => {
    return <SvgIcon {...props}>
        <path d="M18.41 16.59L13.82 12l4.59-4.59L17 6l-6 6 6 6zM6 6h2v12H6z" />
        <path fill="none" d="M24 24H0V0h24v24z" />
    </SvgIcon>
}